import loadable from '@loadable/component'

export const Analyst = loadable(() => import('./Analyst'))
export const Analysts = loadable(() => import('./Analysts'))
export type { AnalystProps } from './Analyst'
export type { AnalystsProps } from './Analysts'
